import { render, staticRenderFns } from "./BlogsPage.vue?vue&type=template&id=a4e14a8e"
import script from "./BlogsPage.vue?vue&type=script&lang=js"
export * from "./BlogsPage.vue?vue&type=script&lang=js"
import style0 from "./BlogsPage.vue?vue&type=style&index=0&id=a4e14a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports